// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"b15af1da","557":"5136bda3"}[chunkId] + ".chunk.js";
};